import { render, staticRenderFns } from "./roleListing.vue?vue&type=template&id=5add1ad1&scoped=true&"
import script from "./roleListing.vue?vue&type=script&lang=js&"
export * from "./roleListing.vue?vue&type=script&lang=js&"
import style0 from "./roleListing.vue?vue&type=style&index=0&id=5add1ad1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5add1ad1",
  null
  
)

export default component.exports